export default "__VITE_ASSET__fd174ce9__"